import { render, staticRenderFns } from "./couponPackage.vue?vue&type=template&id=072274f8&scoped=true"
import script from "./couponPackage.vue?vue&type=script&lang=js"
export * from "./couponPackage.vue?vue&type=script&lang=js"
import style0 from "./couponPackage.vue?vue&type=style&index=0&id=072274f8&prod&lang=scss"
import style1 from "./couponPackage.vue?vue&type=style&index=1&id=072274f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072274f8",
  null
  
)

export default component.exports